<template>
    <div class="dml-page-mega-menu dml-page-mega-menu--special-offer">
        <div class="dml-page-mega-menu__wrap _cf">
            <div class="dml-mega-menu" v-if="!isLoading">
                <template v-for="menuColumn in menuNode.megaMenuNodes">
                    <ul class="dml-mega-menu__list dml-mega-menu__list--narrow">
                        <template v-for="megaMenuItem in menuColumn.lowLevelItems">

                            <li :class="megaMenuItem.cssClass">

                                <a v-if="megaMenuItem.url" :href="megaMenuItem.url"
                                   :data-tracking-click="megaMenuItem.tracking"
                                   data-ga="mega_menu.click_subcategory_element"
                                   :data-ga-label="megaMenuItem.name">{{ megaMenuItem.name }}</a>

                                <span v-else>{{ megaMenuItem.name }}</span>

                            </li>
                        </template>
                    </ul>
                </template>
                <dm-mega-menu-banner :iconsSetVersion="iconsSetVersion" v-if="menuNode.bannerViewModel"
                                     :banner="menuNode.bannerViewModel"></dm-mega-menu-banner>
            </div>
            <dm-page-preloader v-else :isLoading="isLoading" :isStatic="true" />
        </div>
    </div>
</template>
<script>
import MegaMenuBanner from "./mega-menu-banner-component.vue";
import PagePreloader from "../shared/page-preloader-component.vue";

export default {
    name: 'dm-mega-menu-special',
    components: {
        'dm-mega-menu-banner': MegaMenuBanner,
        'dm-page-preloader': PagePreloader,
    },
    props: {
        menuNode: {
            type: Object
        },
        iconsSetVersion: String,
        isLoading: Boolean
    },
    computed:{
        hasData(){
            return this.menuNode.megaMenuNodes !== undefined;
        }
    }
};
</script>
